export default __webpack_public_path__ + "static/eric-8be673429ff990c539df738f5c71589e.png";